/**
 * Admin Users — Metadata Field Definitions
 * Read-only system fields and integration fields (QuickBooks, Meridian).
 */

import type { SimpleFieldConfig } from "@/components/shared/UniversalCRMTable/types/shared";

export const adminUserMetadataFields: Record<string, SimpleFieldConfig> = {
  id: {
    type: "text" as const,
    label: "User ID",
    sortable: true,
    filterable: false,
    searchable: false,
    resizable: true,
    hideable: true,
    editable: false,
    formSpan: 3,
    width: 200,
    minWidth: 150,
    maxWidth: 300,
    allowedRoles: ["wtc_admin"],
    mobileDetailSectionId: "metadata",
  },
  created_at: {
    type: "date" as const,
    label: "Created",
    sortable: true,
    filterable: true,
    searchable: false,
    resizable: true,
    hideable: true,
    editable: false,
    formSpan: 2,
    filterType: "dateRange" as any,
    width: 150,
    minWidth: 120,
    maxWidth: 200,
    allowedRoles: ["wtc_admin"],
    mobileDetailSectionId: "metadata",
  },
  updated_at: {
    type: "date" as const,
    label: "Updated",
    sortable: true,
    filterable: true,
    searchable: false,
    resizable: true,
    hideable: true,
    editable: false,
    formSpan: 2,
    filterType: "dateRange" as any,
    width: 150,
    minWidth: 120,
    maxWidth: 200,
    allowedRoles: ["wtc_admin"],
    mobileDetailSectionId: "metadata",
  },
  // QuickBooks integration fields
  quickbooks_connected_at: {
    type: "date" as const,
    label: "QB Connected",
    sortable: true,
    filterable: true,
    searchable: false,
    resizable: true,
    hideable: true,
    editable: false,
    formSpan: 2,
    filterType: "dateRange" as any,
    width: 150,
    minWidth: 120,
    maxWidth: 200,
    allowedRoles: ["wtc_admin"],
    mobileDetailSectionId: "metadata",
  },
  quickbooks_last_sync_at: {
    type: "date" as const,
    label: "QB Last Sync",
    sortable: true,
    filterable: true,
    searchable: false,
    resizable: true,
    hideable: true,
    editable: false,
    formSpan: 2,
    filterType: "dateRange" as any,
    width: 150,
    minWidth: 120,
    maxWidth: 200,
    allowedRoles: ["wtc_admin"],
    mobileDetailSectionId: "metadata",
  },
  quickbooks_active_realm_id: {
    type: "text" as const,
    label: "QB Active Realm",
    sortable: true,
    filterable: true,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: false,
    formSpan: 2,
    filterType: "contains",
    width: 180,
    minWidth: 150,
    maxWidth: 250,
    allowedRoles: ["wtc_admin"],
    mobileDetailSectionId: "metadata",
  },
  quickbooks_environment: {
    type: "select" as const,
    label: "QB Environment",
    sortable: true,
    filterable: true,
    searchable: false,
    resizable: true,
    hideable: true,
    editable: false,
    formSpan: 1,
    filterType: "equals" as any,
    width: 140,
    minWidth: 120,
    maxWidth: 180,
    options: [
      { value: "production", label: "Production" },
      { value: "sandbox", label: "Sandbox" },
    ],
    allowedRoles: ["wtc_admin"],
    mobileDetailSectionId: "metadata",
  },
  // Meridian integration fields
  meridian_default_email_provider: {
    type: "text" as const,
    label: "Email Provider",
    sortable: true,
    filterable: true,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: false,
    formSpan: 2,
    filterType: "contains",
    width: 150,
    minWidth: 120,
    maxWidth: 200,
    allowedRoles: ["wtc_admin"],
    mobileDetailSectionId: "metadata",
  },
  email_aliases: {
    type: "text" as const,
    label: "Email Aliases",
    sortable: false,
    filterable: false,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: false,
    formSpan: 3,
    width: 200,
    minWidth: 150,
    maxWidth: 350,
    allowedRoles: ["wtc_admin"],
    mobileDetailSectionId: "metadata",
  },
};
